import { ExpressionType } from '../IExpression';
import { IAssignableExpression } from '../repository/assignable/IAssignableExpression';

export function isAssignableExpressionNull(expression: IAssignableExpression) {
  if (!expression) return true;
  return (
    expression.type === ExpressionType.Value &&
    (expression.value == null || expression.value === '')
  );
}
